import React, { useState, useEffect } from "react";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";

import PlatformApplicationChart from "../Charts/PlatformApplications.js";
import PlatformTransactionChart from "../Charts/PlatformTransactions.js"

export default function CardPlatformDashboard(props) {
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    if (Object.keys(props.chartData).length > 0) {
        setChartData(props.chartData);
    }
  }, [props.chartData]);


  return (
      <>
          <div className="relative container mx-auto mb-12 mt-8">


              <div className="relative w-full">
                  <div className="flex flex-wrap">

                      <div className="w-full md:w-4/12 lg:w-4/12 px-4 mb-3">
                          <div className="relative flex flex-col w-full">
                              <div className="w-full bg-white-2 rounded-lg h-95-px flex items-center px-12">
                                  <div className="w-full">
                                      <p className="text-yellow text-16-19 mb-3">Loans</p>
                                      <p className="text-white hl-25">{Math.round(chartData.total_loans / 1e6)}m</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="w-full md:w-4/12 lg:w-4/12 px-4 mb-3">
                          <div className="relative flex flex-col w-full">
                              <div className="w-full bg-white-2 rounded-lg h-95-px flex items-center px-12">
                                  <div className="w-full">
                                      <p className="text-yellow text-16-19 mb-3">Disbursements</p>
                                      <p className="text-white hl-25">${(Math.round(chartData.total_disbursed / 1e6)).toLocaleString(undefined, { minimumFractionDigits: 0 }) }m</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="w-full md:w-4/12 lg:w-4/12 px-4 mb-3">
                          <div className="relative flex flex-col w-full">
                              <div className="w-full bg-white-2 rounded-lg h-95-px flex items-center px-12">
                                  <div className="w-full">
                                      <p className="text-yellow text-16-19 mb-3">Loans Per Minute (Last 30 days)</p>
                                      <p className="text-white hl-25">{chartData.loans_per_minute}</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                  </div>


                  <div className="flex flex-wrap">

                      <div className="w-full md:w-4/12 lg:w-4/12 px-4 mb-3">
                          <div className="relative flex flex-col w-full">
                              <div className="w-full bg-white-2 rounded-lg h-95-px flex items-center px-12">
                                  <div className="w-full">
                                      <p className="text-yellow text-16-19 mb-4">Registered Customers</p>
                                      <p className="text-white hl-25">{Math.round(chartData.opt_ins / 1e6)}m</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="w-full md:w-4/12 lg:w-4/12 px-4 mb-3">
                          <div className="relative flex flex-col w-full">
                              <div className="w-full bg-white-2 rounded-lg h-95-px flex items-center px-12">
                                  <div className="w-full">
                                      <p className="text-yellow text-16-19 mb-4">Eligible Customers</p>
                                      <p className="text-white hl-25">{Math.round(chartData.total_eligible / 1e6)}m</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="w-full md:w-4/12 lg:w-4/12 px-4 mb-3">
                          <div className="relative flex flex-col w-full">
                              <div className="w-full bg-white-2 rounded-lg h-95-px flex items-center px-12">
                                  <div className="w-full">
                                      <p className="text-yellow text-16-19 mb-4">Applications (Last 30 days)</p>
                                      <p className="text-white hl-25">{Math.round(chartData.total_applications / 1e6)}m</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                  </div>


              </div>


              <div className="relative w-full px-4 mb-3">
                  <div className="relative bg-white-2 w-full rounded-lg p-4 mb-3">
                      <PlatformApplicationChart
                          qualifiedApplications={chartData.chart_qualified}
                          unqualifiedApplications={chartData.chart_unqualified}
                          labels={chartData.chart_date}
                          title='Monthly Applications'
                      />
                  </div>
              </div>

              <div className="relative w-full px-4 mb-3">
                  <div className="relative bg-white-2 w-full rounded-lg p-4 mb-3">
                      <PlatformTransactionChart
                          collections={chartData.chart_coll}
                          disbursements={chartData.chart_disb}
                          labels={chartData.chart_date}
                          title='Monthly Transactions'
                      />
                  </div>
              </div>

          </div>

      </>
  );
}
